module.exports = __webpack_public_path__ + "img/maintenance-of-dogs-en.bda58a88.svg";